import { Card } from '@/common/ui/Card'
import { OrgForm } from '@/app/entities/org/ui'
import { OrgInvitationsTable } from '@/app/entities/orgInvitations/ui'
import { OrgMembersTable } from '@/app/entities/orgMembers/ui'
import { Button } from '@/common/ui/Form/Button'
import { Icon } from '@/common/ui/Icon'

export const OrgProfilePage = () => {
    return (
        <>
            <div className='profile-content flex flex-wrap items-center justify-between gap-4'>
                <h2 className='font-medium text-[20px]/[22px]'>Организация</h2>
                <Button
                    as='label'
                    htmlFor='addOrgModal'
                    emphasis='secondary'
                    variant='ghost'
                    size='lg'
                    className='shrink-0'
                >
                    <Icon name='plus' size='md' />
                    Добавить организацию
                </Button>
            </div>
            <Card className='profile-content card-primary' tableScroll>
                <OrgForm className='two-columns' />
                <OrgMembersTable className='grid-cols-2' />
                <OrgInvitationsTable className='grid-cols-2' />
            </Card>
        </>
    )
}
